<template>
  <el-row class="tac">
    <el-menu
      default-active="1"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      :unique-opened="true"
      background-color="#23262c"
      text-color="#b8c7ce"
      active-text-color="#fff"
      style="height: 100%"
    >
      <router-link to="/Index">
        <el-menu-item index="999">
          <i class="iconfont icon-zhanghuzonglan"></i>
          <span slot="title">{{$t('Nav.Overview')}}</span>
        </el-menu-item>
      </router-link>



      <el-submenu
        :index="key + 1 + ''"
        v-for="(item, key) in TreeList.submenu"
        :key="key"
      >
        <template slot="title">
          <i class="iconfont " :class="[item.ico]"></i>

          {{item.title}}

        </template>
        <!--<template slot="title">{{item.title}}</template>-->
        <router-link
          :to="item2.url"
          v-for="(item2, key2) in item.submenu"
          :key="key2"
        >
          <el-menu-item :index="key + 1 + '-' + (key2 + 1)">
            <i class="iconfont  " :class="[item2.ico]"></i>

            {{item2.title}}
          </el-menu-item>
        </router-link>
      </el-submenu>
      <!--<el-submenu index="9999"  >-->
        <!--<template slot="title">-->
          <!--<i class="iconfont  icon-gongsiguanli"></i>  <span > 公司模块 </span>-->
        <!--</template>-->
        <!--<router-link  to="/companybundle/index" > <el-menu-item index="9999-1">  基本信息 </el-menu-item>    </router-link>-->
        <!--<router-link  to="/companybundle/noplatuser" >  <el-menu-item index="9999-2">  联系人     </el-menu-item></router-link>-->
        <!--<router-link  to="/companybundle/platuser" > <el-menu-item index="9999-3">  部门人员管理 </el-menu-item></router-link>-->
      <!--</el-submenu>-->
      <!--<el-submenu index="9998"  >-->
        <!--<template slot="title">-->
          <!--<i class="iconfont  icon-gongsiguanli"></i>  <span > 公司管理 </span>-->
        <!--</template>-->
        <!--<router-link  to="/companyAdmin/CompanyAdd" > <el-menu-item index="9998-1">  新增公司 </el-menu-item>    </router-link>-->
        <!--<router-link  to="/companyAdmin/Company" >  <el-menu-item index="9998-2">  公司列表     </el-menu-item></router-link>-->
      <!--</el-submenu>-->
      <!--<el-submenu index="9997">-->
        <!--<template slot="title">-->
          <!--<i class="iconfont  icon-gongsiguanli"></i>  <span > 用户管理 </span>-->
        <!--</template>-->
        <!--<router-link  to="/UserAdd" > <el-menu-item index="9997-1">  新增用户 </el-menu-item>    </router-link>-->
        <!--<router-link  to="/User" >  <el-menu-item index="9997-2">  用户列表     </el-menu-item></router-link>-->
      <!--</el-submenu>-->
      <!--<el-submenu index="9996">-->
        <!--<template slot="title">-->
          <!--<i class="iconfont  icon-gongsiguanli"></i>  <span > 权限管理 </span>-->
        <!--</template>-->
        <!--<router-link  to="/Permission" > <el-menu-item index="9996-1">  权限 </el-menu-item>    </router-link>-->
        <!--<router-link  to="/PermissionGroup" >  <el-menu-item index="9996-2">  权限组     </el-menu-item></router-link>-->
      <!--</el-submenu>-->

    </el-menu>
  </el-row>
</template>

<script>
export default {
  data() {
    return {
      TreeList: [],
      Yundan: [],
      locale:'',
    };
  },
  mounted() {
    this.locale=this.$i18n.locale;
    this.getTree();
  },
  methods: {
    getTree() {
      //树结构获取
      this.$axios
        .get(this.configUrl + "/Permission/PermissionTree", {
          params: {
            siteguid: "12193032-2D60-6F2B-1944-B707D8D7E7A9",
            ispower: false
          }
        })
        .then(res => {
          let data = JSON.parse(res.data);
          let ary = data.results.menu[0];
          let other = [];
          ary.submenu.forEach((item, index) => {
            if (item.title == "运单查询" || item.title == "运单管理") {
              this.Yundan.push(item);
            } else {
              other.push(item);
            }
          });
          data.results.menu[0].submenu = other;

          this.TreeList = data.results.menu[0];
        })
        .catch(err => {});
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    }
  }
};
</script>

<style scoped>
.el-menu-item:hover {
  color: #fff !important;
  background-color: #2479f0 !important;
}

.is-active {
  background-color: #2479f0 !important;
}

.el-menu-item:hover i {
  color: #fff !important;
}

/*.el-submenu__title:hover{*/
/*color:#fff !important;*/
/*background-color: #2479f0 !important;*/
/*}*/
.iconfont {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Nav.vue